import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { BrandService } from './brand.service';

@Injectable({ providedIn: 'root' })
export class BrandOnlyGuard implements CanMatch {
  constructor(private brand: BrandService) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    const allowedStr = route.data?.['brandOnly'] as string | undefined;
    if (!allowedStr) return true;

    const allowed = allowedStr.split(',').map(s => s.trim());
    return allowed.includes(this.brand.brandId);
  }
}
